import {SODeleteStep} from '../../core/step/so-delete-step';
import {DeleteEntityProtocol} from 'lionheartland';
import {BaseDelete} from 'lionheartland';


export class RADeleteStep extends BaseDelete implements DeleteEntityProtocol {
  deleteClass = SODeleteStep;
}